// eslint-disable-next-line no-restricted-imports
import { FlatList } from 'dripsy';

export default FlatList;
